<template>
  <div id="er-dashboard" class="animated fadeIn">
    <MetricOpt @change-dashboard-indicator="changeDashboardIndicator" />
  </div>
</template>

<script>
  import MetricOpt from '@/expertoRetail/components/SellOutAccumulatedMetricOpt/MetricOpt'

  export default {
    name: 'SellOutMetricComponent',
    props: [],
    components: {
      MetricOpt
    },
    data () {
      return {
        filters: {},
        myToggle: false,
        buttons: [
          {
            id: 1,
            variant: 'outline-info',
            caption: 'U',
            state: false,
            value: 'UNITS'
          },
          {
            id: 2,
            variant: 'outline-info',
            caption: '$',
            state: false,
            value: 'PESOS'
          }
        ]
      }
    },
    methods: {
      routerGoto (view) {
        this.$router.push({name: view})
      },
      changeDashboardIndicator (item) {
        this.$emit('change-dashboard-indicator', item)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/expertoRetail/components/SellOutAccumulatedMetricOpt/SelloutMetricPane.vue